import styled from 'styled-components';
import { ReactComponent as Logo } from 'src/assets/emptyMyTicketsTable.svg';

export const EmptyContentWrapper = styled.div`
  position: absolute;
  gap: 12px;
`;

export const EmptyContent = styled.div` 
  gap: 32px;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 120px;
`;

export const EmptyNotesLogo = styled(Logo)`
  width: 100%;
  height: 100%;
`;

export const EmptyContentTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmptyContentTitle = styled.h2`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const EmptyContentSubtitle = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;